module.exports = __webpack_public_path__ + "static/media/town.be7389b3.jpg";